/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolToolsPowerDrillIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-tools-power-drill"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.75 10.5L11 10.5Q11.4 10.5 11.7 10.2Q12 9.9 12 9.5Q12 9.1 11.7 8.8Q11.4 8.5 11 8.5L6.75 8.5Q6.35 8.5 6.05 8.8Q5.75 9.1 5.75 9.5Q5.75 9.9 6.05 10.2Q6.35 10.5 6.75 10.5ZM6.75 7.75L11 7.75Q11.4 7.75 11.7 7.45Q12 7.15 12 6.75Q12 6.35 11.7 6.05Q11.4 5.75 11 5.75L6.75 5.75Q6.35 5.75 6.05 6.05Q5.75 6.35 5.75 6.75Q5.75 7.15 6.05 7.45Q6.35 7.75 6.75 7.75ZM17.4 11.5L17.4 4.75L17.65 4.75Q18.6 4.75 19.32 5.35Q20.05 5.95 20.25 6.85L20.25 6.85L21.98 6.85Q22.52 6.85 22.91 7.24Q23.3 7.63 23.3 8.18Q23.3 8.72 22.91 9.11Q22.52 9.5 21.98 9.5L20.23 9.5L20.23 9.5Q20 10.38 19.3 10.94Q18.6 11.5 17.65 11.5ZM12.4 16L5.35 16L5.35 14.1L5.35 14.1Q3.63 13.82 2.49 12.53Q1.35 11.22 1.35 9.5L1.35 6.75Q1.35 4.83 2.71 3.46Q4.08 2.1 6 2.1L13.75 2.1Q14.88 2.1 15.64 2.86Q16.4 3.63 16.4 4.75L16.4 11.5Q16.4 12.63 15.64 13.39Q14.88 14.15 13.75 14.15L12.4 14.15ZM4.67 22.3Q3.85 22.3 3.27 21.71Q2.7 21.13 2.7 20.3L2.7 18.98Q2.7 18.15 3.27 17.57Q3.85 17 4.67 17L13.07 17Q13.9 17 14.47 17.57Q15.05 18.15 15.05 18.98L15.05 20.3Q15.05 21.13 14.47 21.71Q13.9 22.3 13.07 22.3Z" fill={color} />
    </svg>
  );
}
